export const ID = 'QUESTION_MODERATION';

export const SEARCH_AUTHOR = `${ID}/SEARCH_AUTHOR`;
export const SEARCH_AUTHOR_COMPLETED = `${ID}/SEARCH_AUTHOR_COMPLETED`;
export const SEARCH_AUTHOR_FAILED = `${ID}/SEARCH_AUTHOR_FAILED`;
